/**
 * Media type detection utilities for consistent video/image handling
 */

export const isVideoUrl = (url: string): boolean => 
  /\.(mp4|webm|mov|ogg|gif)$/i.test(url);

export const isImageUrl = (url: string): boolean => 
  /\.(jpg|jpeg|png|webp|svg|avif)$/i.test(url);
